import * as React from 'react';
import {EzProvider, EzThemeProvider, themes, stitchesMarketplaceTheme} from '@ezcater/recipe';

const StylesProvider: React.FC<React.PropsWithChildren<unknown>> = ({children}) => (
  <EzThemeProvider theme={themes.ezMarketplaceTheme}>
    <EzProvider theme={stitchesMarketplaceTheme}>{children}</EzProvider>
  </EzThemeProvider>
);

export default StylesProvider;
